import React, { useState } from 'react';
import { Flex, Text } from "@chakra-ui/layout";
import { Props } from 'framer-motion/types/types';
import { Alert, AlertIcon, AlertTitle, Badge, Button, FormControl, FormErrorMessage, FormLabel, Progress, useToast } from '@chakra-ui/react';
import axios from 'axios';
import { StateType } from '../../../store/store';
import { useSelector } from 'react-redux';

function SubmitAssignment({ match }: Props) {
  console.log(match.params.assignmentId);
  const { data: { token }, assignments: { assignments } } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));
  console.log(studentToken);
  const assignmentId = match.params.assignmentId;
  const ass = assignments.filter((value, index, arr) => value.assignment_id === assignmentId)
  console.log(ass);
  const [assignment, setAssignment] = useState<FileList | null>(null);
  const [assignmentError, setAssignmentError] = useState<string>("");
  const [loaded, setLoaded] = useState(0);
  const toast = useToast();

  function handleAssignmentUpload(e: React.ChangeEvent<HTMLInputElement>) {
    console.log(e.target.files);
    let assignments = e.target.files;
    let size = 3221225472; //3gb
    // check size and length
    if (assignments === null) return;
    if (assignments.length > 3) {
      console.log("assignments more than 3");
      setAssignmentError("you cannot upload more than 3 files")
      assignments = null;
      return;
    }
    const noteTypes = ['image/png', 'image/jpeg', 'application/pdf', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/msword', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    for (let i = 0; i < assignments.length; i++) {
      // compare note type, find doesn't match
      if (noteTypes.every(type => !(assignments) || assignments[i].type !== type)) {
        // create error message and assign to container
        setAssignmentError(assignments[i].type + ' is not a supported format');
        return assignments = null;
      }
    }
    // check size
    for (let i = 0; i < assignments.length; i++) {
      if (assignments[i].size > size) {
        setAssignmentError(assignments[i].type + "is too large, please pick a smaller file");
        return assignments = null;
      }
    }
    setAssignmentError("")
    if (assignmentError !== "") {
      assignments = null;
      return
    }
    setAssignment(assignments);
  }

  async function submitAssignment(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (assignment === null) {
      return setAssignmentError("Please choose an assignment to upload")
    }
    setAssignmentError("");
    const uploadData = new FormData();
    uploadData.append("assignmentId", assignmentId);
    for (let i = 0; i < assignment.length; i++) {
      uploadData.append(assignment[i].name, assignment[i])
    }
    const res = await axios.post("/user/student/submit-assignment", uploadData, {
      headers: {
        'content-type': 'multipart/form-data',
        "Authorization": `Bearer ${studentToken}`
      },
      onUploadProgress: progressEvent => {
        setLoaded(progressEvent.loaded / progressEvent.total * 100)
      }
    })
    console.log(res);
    toast({
      title: "Upload Status",
      description: `${res.data.message}`,
      status: "success",
      duration: 9000,
      isClosable: true,
    })
    console.log('assignment submitted')
  }

  return (
    <Flex m={7} p={7} flexDirection={'column'} bgColor={"white"} boxShadow="2xl" borderRadius={"30px"}>
      <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"2xl"}>Submit Assignment</Text>
      <Flex justifyContent="space-between">
        <Text textTransform={"capitalize"} fontWeight={"bold"} fontSize={"xl"}>{ass[0].course_name}</Text>
        <Badge alignSelf="center" padding="1" variant="solid" colorScheme="blackAlpha" borderRadius="20px">Due {ass[0].assignment_due_date}</Badge>
      </Flex>
      <Text textTransform="capitalize" fontWeight="medium">{ass[0].teacher_username}</Text>
      <hr />
      <Flex>
        <form encType="multipart/form-data" onSubmit={(e) => submitAssignment(e)}>
          <Alert d={assignmentError === "" ? "none" : "flex"} status="error">
            <AlertIcon />
            <AlertTitle mr={2}>{assignmentError}</AlertTitle>
          </Alert>
          <FormControl isInvalid={assignmentError !== null} my={5}>
            <FormLabel htmlFor={"note"} fontWeight={"semibold"}>Assignment/File</FormLabel>
            <input id={"assignment"} type="file" multiple onChange={(e) => handleAssignmentUpload(e)} />
            <FormErrorMessage>{assignmentError}</FormErrorMessage>
          </FormControl>
          <Progress hasStripe value={loaded} max={100} mb={4} />
          <Button type={"submit"} bgColor={"brand.darkGreen"}>submit assignment</Button>
        </form>
      </Flex>
    </Flex>
  );
}

export default SubmitAssignment;